/**
 * Observer
 */
export default class {
  update() {
    console.log('Observer update');
  }
}
